// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { systemBuilderTypesViewStyles } from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderTypesView";
import { xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

systemBuilderTypesViewStyles.typesWrapper = {
    css: css`
        display: flex;
        column-gap: 22px;
        justify-content: center;
        ${xScreen("lte", "md")} {
            justify-content: flex-start;
            padding-bottom: 188px;
        }
        ${xScreen("lte", 767)} {
            flex-direction: column;
            align-items: start;
            row-gap: 16px;
            padding-bottom: 0;
        }
    `,
};
